'use client';
import { OPTION_PANEL_TEST_IDS } from '@susu/custom-made/utils/testIds/optionPanel.testIds';
import cn from 'classnames';
import type { ReactNode } from 'react';

/**
 * Sticky search/filter header shared by `FabricPanel` and `OptionPanel`: a 3-column row (search
 * slot, item count, optional filter slot) that slides up under the panel's fixed top nav on
 * scroll. Only the container + item-count span were identical between the two panels — the
 * search/filter buttons keep their own markup (positioning, testids, click handlers differ per
 * panel) and are passed in as slots.
 */
const CONTAINER_CLASSES =
  'lg:transition-[transform] lg:duration-400 lg:ease-[cubic-bezier(0.5,0.05,0.1,1)] lg:absolute lg:top-[82px] lg:left-0 lg:right-0 lg:bg-white lg:z-1 lg:grid lg:grid-cols-[1fr_auto_1fr] lg:items-center lg:pb-8 2xl:top-[88px]';

const ITEM_COUNT_CLASSES = 'hidden lg:flex lg:items-center lg:justify-self-center lg:text-sm lg:leading-sm';

interface PanelSearchHeaderProps {
  isVisible: boolean;
  itemCountLabel: string;
  searchSlot: ReactNode;
  filterSlot?: ReactNode;
  className?: string;
}

export const PanelSearchHeader = ({
  isVisible,
  itemCountLabel,
  searchSlot,
  filterSlot,
  className,
}: PanelSearchHeaderProps) => (
  <div className={cn(CONTAINER_CLASSES, isVisible ? 'lg:translate-y-0' : 'lg:translate-y-[-120%]', className)}>
    {searchSlot}
    <span className={ITEM_COUNT_CLASSES} data-testid={OPTION_PANEL_TEST_IDS.ITEM_COUNT_LABEL}>{itemCountLabel}</span>
    {filterSlot}
  </div>
);
